import {useCallback, useState} from 'react';

export const useOnSearch = (asyncCb, successCb, failCb) => {
  const [loading, setLoading] = useState(false);

  const onLoad = useCallback(
    searchTerm => {
      setLoading(true);
      if (searchTerm?.length > 2) {
        asyncCb(searchTerm).then(
          (...args) => {
            successCb(...args);
            setLoading(false);
          },
          error => {
            failCb(error);
            setLoading(false);
          }
        );
      } else {
        setLoading(false);
        failCb();
      }
    },
    [asyncCb, setLoading, successCb, failCb]
  );

  return {loading, onLoad};
};
